export default "__VITE_ASSET__BVi7sMUh__"